import http from "./HttpService";

export const getAnlagentypEndpoint = "/anlagentyp";
export const getAuflagenartEndpoint = "/auflagenart/";
export const getAsParameterEndpoint = "/as-parameter/";
export const getAsEinheitEndpoint = "/as-einheit/";
export const getBauwerkAnlageteilBezeichnungEndpoint = "/bauwerk-anlageteil-bezeichnung/";
export const getBauwerkAnlageteilKategorieEndpoint = "/bauwerk-anlageteil-kategorie/";
export const getBauwerkBezeichnerEndpoint = "/bauwerk-bezeichner/";
export const getBauwerkEinheitEndpoint = "/bauwerk-einheit/";
export const getHaupttaetigkeitEndpoint = "/haupttaetigkeit/";
export const getNaceCodeEndpoint = "/nace-code/";
export const getPlanungMassnahmeEndpoint = "/planung-massnahme/";
export const getPlanungStatusEndpoint = "/planung-status/";
export const getProduktbezeichnungEndpoint = "/produktbezeichnung/";
export const getProduktionsartEndpoint = "/produktionsart/";
export const getProduktionsverfahrenEndpoint = "/produktionsverfahren/";
export const getTaetigkeitEndpoint = "/taetigkeit/";
export const getBImSchVEndpoint = "/bimschv/";
export const getBvtBrefEndpoint = "/bvt-bref/";
export const getPrtrVoEndpoint = "/prtr-vo/";
export const getZustaendigkeitPersonEndpoint = "/zustaendigkeit-person/";
export const getAllBescheidArtEndpointEndpoint = "/bescheidart";
export const getMessstellentypEndpoint = "/messstellentyp/";
export const getAnredeEndpoint = "/anrede/";
export const getTitelEndpoint = "/titel/";
export const getAnlagenartEndpoint = "/anlagenart";
export const getBetriebsTypEndpoint = "/betriebstyp/";
export const getBetriebsstatusEndpoint = "/betriebsstatus/";
export const getRaeumlicheEndpoint = "/raeumlicheskriterium/";
export const getRegionalstelleEndpoint = "/regionalstelle/";
export const getAnlagenSystemEndpoint = "/anlagensystem/";
export const getAbwasserartEndpoint = "/abwasserart/";
export const getMessstelleAbwasserartEndpoint = "/messstelle-abwasserart/";
export const getMessstelleAnhangEndpoint = "/anhang-abwv/";
export const getMessstellenZustaendigkeitEndpoint = "/messstellenzustaendigkeit";
export const getKanalMaterialartEndpoint = "/kanal-materialart/";
export const getKanalsystemEndpoint = "/kanalsystem/";
export const getKuehlartEndpoint = "/kuehlart/";
export const getEntlastungstypEndpoint = "/entlastungstyp/";
export const getEntlastungsanlagenartEndpoint = "/entlastungsanlageart/";
export const getEntlastungssystemEndpoint = "/entlastungssystem/";
export const getBescheidQualitaetEndpoint = "/bescheidqualitaet/";
export const getBehoerdeEndpoint = "/behoerde/";
export const getAnforderungRandbedingungenEndpoint = "/anforderung-randbedingung/";
export const getAnforderungVorbehandlungenEndpoint = "/anforderung-vorbehandlung/";
export const getAnforderungWertEndpoint = "/anforderung-wert/";
export const getBiologischeBehandlungEndpoint = "/biologische_behandlung";
export const getSchlammbehandlungEndpoint = "/schlammbehandlung";
export const getVorbehandlungEndpoint = "/vorbehandlung/";
export const getChemischeBehandlungEndpoint = "/chemische-behandlung/";
export const getNachbehandlungEndpoint = "/nachbehandlung/";
export const getSuevoaAnlageNrEndpoint = "/suevoaAnlageNr/"

export const getAnforderungEinheitenEndpoint = (betriebstyp, parameterart) => {
    return "/anforderung-einheit?betriebstyp=" + betriebstyp + (parameterart ? "&parameterArt=" + parameterart : "");
}

export function getAnforderungProbenahmenEndpoint(betriebstyp, parameterart) {
    return "/anforderung-probenahme?betriebstyp=" + betriebstyp + (parameterart ? "&parameterArt=" + parameterart : "");
}

export function getAnforderungsparameterEndpoint(betriebstyp, parameterart = null) {
    return "/anforderungsparameter?betriebstyp=" + betriebstyp + (parameterart ? "&anforderungsparameterart=" + parameterart : "");
}

export function getUsedAnforderungsparameterByBetriebEndpoint(betriebId) {
    return "/betrieb/" + betriebId + "/anforderungsparameter/";
}

export function getAnforderungHaeufigkeitenEndpoint(betriebstyp) {
    return "/anforderung-haeufigkeit?betriebstyp=" + betriebstyp;
}

export function getFilteredBescheidArtenEndpoint(bescheidQualitaetId) {
    return bescheidQualitaetId ? "/bescheidart?bescheidQualitaet=" + bescheidQualitaetId : "/bescheidart";
}

export function getSelbstueberwachungVorlagenEndpoint() {
    return "/selbstueberwachungVorlage";
}

export function postAnforderung(bericht) {
    return http.post("/anforderung", bericht);
}

export function putAnforderung(bericht) {
    return http.put("/anforderung", bericht);
}